import React from "react";

const UnauthorizedPage: React.FC = () => {
  const handleClose = () => {
    window.history.back();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        textAlign: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px 40px",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
          maxWidth: "420px",
          width: "90%",
          margin: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h5 style={{ color: "#dc3545", fontWeight: 600, margin: 0 }}>
            <i className="fas fa-lock mr-2"></i>Access Denied
          </h5>
          <button
            onClick={handleClose}
            type="button"
            style={{
              background: "none",
              border: "none",
              fontSize: "1.2rem",
              cursor: "pointer",
              color: "#888",
            }}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <div>
          <i
            className="fas fa-exclamation-triangle"
            style={{
              fontSize: "50px",
              color: "#ffc107",
              marginBottom: "20px",
            }}
          ></i>
          <p style={{ fontWeight: "bold", fontSize: "18px" }}>
            You do not have permission to perform this action.
          </p>
          <p style={{ fontSize: "14px", color: "#666" }}>
            Please contact your administrator to request access.
          </p>
        </div>

        <button
          className="btn btn-outline-secondary"
          onClick={handleClose}
          style={{
            marginTop: "20px",
            borderColor: "#9c27b0",
            color: "#9c27b0",
            fontWeight: 500,
            boxShadow: "0px 2px 4px rgba(156, 39, 176, 0.4)",
          }}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
